export default __webpack_public_path__ + "static/media/default-image.26d6c716.svg";